import script from "./TablaClasificacionEloEquipos.vue?vue&type=script&setup=true&lang=ts"
export * from "./TablaClasificacionEloEquipos.vue?vue&type=script&setup=true&lang=ts"

import "./TablaClasificacionEloEquipos.vue?vue&type=style&index=0&id=35ba977d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35ba977d"]])

export default __exports__